import React from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { SEOHead } from '@/components/seo/SEOHead';

export default function AboutListingsPage() {
  return (
    <MainLayout>
      <SEOHead
        title="How our listings work | Jigsaw Events Hub"
        description="How Jigsaw Events Hub compiles, presents and controls event information, and what visitors should verify before booking or travelling."
      />

      <section className="bg-[radial-gradient(circle_at_top_left,_rgba(249,115,22,0.14),_transparent_30%),linear-gradient(180deg,_#fff8f1_0%,_#ffffff_45%,_#f8fafc_100%)] px-4 py-20">
        <div className="mx-auto max-w-3xl space-y-8">
          <div className="space-y-4">
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-orange-700" data-testid="about-listings-eyebrow">About our listings</p>
            <h1 className="text-4xl font-bold text-slate-900 sm:text-5xl" data-testid="about-listings-title">How our listings work</h1>
          </div>

          <div className="space-y-6 rounded-[1.75rem] border border-slate-200 bg-white p-8 shadow-sm" data-testid="about-listings-body">
            <p className="text-base leading-8 text-slate-700">
              Jigsaw Events Hub is an independent event discovery, research and delegate-support platform operated by Jigsaw Conferences Ltd.
            </p>
            <p className="text-base leading-8 text-slate-700">
              Event information may be compiled from publicly available information, third-party sources and automated research systems. We apply publication controls designed to support the quality and relevance of our listings. However, events and external websites can change, and information may occasionally be incomplete, outdated or inaccurate.
            </p>
            <p className="text-base leading-8 text-slate-700">
              Unless expressly stated on the relevant page, Jigsaw Conferences Ltd is not the event organiser, ticket seller, promoter, sponsor, partner, representative or affiliate. The inclusion of an event, organiser name, venue or external link does not, by itself, indicate authorisation, affiliation or endorsement.
            </p>
            <p className="text-base leading-8 text-slate-700">
              Before purchasing tickets, making payment, sharing personal information or arranging travel or accommodation, please confirm the organiser, destination website, dates, venue and applicable booking conditions.
            </p>
            <p className="text-base leading-8 text-slate-700" data-testid="about-listings-correction">
              If you are an organiser, rights holder or user and believe that a listing requires correction, please email{' '}
              <a href="mailto:it@jigsawconferences.co.uk" className="font-medium text-orange-700 underline underline-offset-4">it@jigsawconferences.co.uk</a>
              {' '}and include the relevant page URL.
            </p>
          </div>
        </div>
      </section>
    </MainLayout>
  );
}
